import { render, staticRenderFns } from "./perf.vue?vue&type=template&id=7320513b&scoped=true&lang=pug&"
import script from "./perf.vue?vue&type=script&lang=js&"
export * from "./perf.vue?vue&type=script&lang=js&"
import style0 from "./perf.vue?vue&type=style&index=0&id=7320513b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7320513b",
  null
  
)

export default component.exports